module.exports = __webpack_public_path__ + "static/media/unchecked.2fe50ff4.png";